import {Injectable} from '@angular/core';
import {
    AbstractDataServiceDtoAdapter
} from '../../../../../core/service/v2/dataservice/adapter/abstractDataServiceDto.adapter';
import {CommunicationContentModelConverter} from '../../../api/entity/converter/communicationContentModel.converter';
import {CommunicationContentModelDataService} from './communicationContentModelData.service';
import {CommunicationContentModelModel} from '../../../api/entity/communicationContentModel.model';

@Injectable()
export class CommunicationContentModelDataServiceAdapter
    extends AbstractDataServiceDtoAdapter<CommunicationContentModelModel, CommunicationContentModelConverter> {
    constructor(dataService: CommunicationContentModelDataService, converter: CommunicationContentModelConverter) {
        super(dataService, converter);
    }

    newStoredEntityInstance(): CommunicationContentModelModel {
        return new CommunicationContentModelModel();
    }
}
